import ErrorView from 'views/ErrorView'

export default function ErrorPage() {
  return <div>{<ErrorView />}</div>
}
